import { z } from 'zod'

// Mirrors TrackByReferenceDto.
export const trackByReferenceSchema = z.object({
  reference: z.string().min(1, 'Enter your Reference ID.'),
  mobile: z.string().regex(/^[6-9]\d{9}$/, 'Enter a valid 10-digit mobile number.'),
})

export type TrackByReferenceFormValues = z.infer<typeof trackByReferenceSchema>
